import getAxiosInstance from "../../common/mhiAxios";
import { parseRecoUser, parseUserVideo } from "./HomePageReducer";

export default {
    // -----------------------------------------------------------------------------------
    // おすすめビデオ
    // 取得
    GetRecommendVideoList(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getRecommendVideoList", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 編集
    UpdateRecVideos(videoIds: string[], userId: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateRecVideo", { videoIds: videoIds, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 追加
    AddVideoToRec(videoId: string): Promise<void> {
        return getAxiosInstance()
            .post("/api/addVideoToRec", { videoId: videoId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 削除
    DelVideoFromRec(videoId: number): Promise<void> {
        return getAxiosInstance()
            .get(`/api/deleteVideoToRec?videoId=${videoId}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // -----------------------------------------------------------------------------------
    // おすすめチャンネル
    // 取得
    GetRecommendProgramList(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getRecommendChannelList", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 編集
    UpdateRecPrograms(programIds: string[], userId: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateRecChannel", { programIds: programIds, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 追加
    addRecProgram(id: number, userId: string): Promise<number[]> {
        return getAxiosInstance()
            .post("/api/addRecChannel", { programId: id, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 削除
    delRecProgram(id: number, userId: string): Promise<number[]> {
        return getAxiosInstance()
            .post("/api/deleteRecChannel", { programId: id, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // -----------------------------------------------------------------------------------
    // おすすめプロフェショナル
    // 取得
    GetRecommendProfessionalList(userId: number): Promise<any> {
        return getAxiosInstance()
            .post(`/api/getRecommendProfessionalList?userId=${userId}`)
            .then(({ data }) => data.map(parseRecoUser))
            .catch((error) => {
                return error;
            });
    },
    // 編集
    UpdateRecProfessionals(professionalIds: string[]): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateRecProfessional", professionalIds)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 追加
    addRecProfessional(id: number): Promise<number[]> {
        return getAxiosInstance()
            .post(`/api/addRecProfessional/${id}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 削除
    removeRecProfessional(id: number): Promise<number[]> {
        return getAxiosInstance()
            .post(`/api/deleteRecProfessional/${id}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // -----------------------------------------------------------------------------------
    // 新着ビデオ
    // 取得
    GetNewVideoList(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getNewVideoList", { params: { userId: userId } })
            .then(({ data }) => data.map(parseUserVideo))
            .catch((error) => {
                return error;
            });
    },
    // -----------------------------------------------------------------------------------
    // ユーザー視聴履歴
    // 取得
    GetVideosByUser(userId: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getVideoListByUser", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
